<template>
  <div class="glue">
    <GlueList />
  </div>
</template>

<script>
// @ is an alias to /src
import GlueList from "@/components/GlueList.vue";

export default {
  name: "Glue",
  components: {
    GlueList
  }
};
</script>
